// Legal document type mapping
export const DOC_TYPE_MAP: Record<string, string> = {
  "privacy-policy": "privacy-policy",
  "data-processing-agreement": "data-processing-agreement",
  "terms-and-conditions": "stripe-tc",
} as const;

// Valid languages (matching i18n configuration)
export const VALID_LANGUAGES = ["en", "de"] as const;
export type Language = (typeof VALID_LANGUAGES)[number];

// Language options for dropdowns (matching i18n languageList format)
export const LANGUAGE_OPTIONS = [
  { value: "en", label: "English", abbr: "EN" },
  { value: "de", label: "Deutsch", abbr: "DE" },
] as const;

// Document titles by type and language
export const DOCUMENT_TITLES: Record<string, Record<Language, string>> = {
  "privacy-policy": {
    en: "Privacy Policy",
    de: "Datenschutzerklärung",
  },
  "data-processing-agreement": {
    en: "Data Processing Agreement",
    de: "Auftragsverarbeitungsvertrag",
  },
  "terms-and-conditions": {
    en: "Terms and Conditions",
    de: "Allgemeine Geschäftsbedingungen",
  },
} as const;

// Cache configuration for legal documents
export const LEGAL_CACHE_CONFIG = {
  TTL: 1000 * 60 * 60, // 1 hour cache TTL
} as const;
